<div class="modern-container">
  <!-- Modern Header -->
  <div class="modern-header">
    <div class="header-left">
      <h1 class="header-title">Piezo Designer</h1>
      <span class="header-subtitle">Drag & Drop Configuration</span>
    </div>
    <div class="header-actions">
      <button mat-stroked-button class="modern-btn btn-icon" (click)="uploadImage()" title="Upload Images">
        <i class="fas fa-cloud-upload-alt"></i>
        <span>Upload</span>
      </button>
      <button [disabled]="powertrainCanvasItems.length==0" mat-stroked-button class="modern-btn btn-primary"
        (click)="addPowerTrainSensor()">
        <i class="fas fa-plus-circle"></i>
        <span>Add Sensor</span>
      </button>
      <button [disabled]="powertrainCanvasItems && powertrainCanvasItems[0]?.sensors?.length==0" mat-stroked-button
        class="modern-btn btn-success" (click)="openPowertrainNameModalBox()">
        <i class="fas fa-save"></i>
        <span>Save</span>
      </button>
      <button mat-stroked-button class="modern-btn btn-danger" (click)="deleteCanvasSensor()">
        <i class="fas fa-trash-alt"></i>
        <span>Clear</span>
      </button>
      <button mat-stroked-button class="modern-btn btn-primary" (click)="onCancel()">
        <i class="fas fa-trash-alt"></i>
        <span>Cancel</span>
      </button>
    </div>
  </div>

  <!-- Main Content Area -->
  <div class="content-wrapper">
    <!-- Collapsible Sidebar -->
    <div class="modern-sidebar" [class.collapsed]="sidebarCollapsed">
      <div class="sidebar-toggle" (click)="toggleSidebar()">
        <i class="fas" [ngClass]="sidebarCollapsed ? 'fa-chevron-right' : 'fa-chevron-left'"></i>
      </div>

      <div class="sidebar-content" *ngIf="!sidebarCollapsed">
        <div class="sidebar-section">
          <h3 class="sidebar-title">
            <i class="fas fa-images"></i>
            Available Images
          </h3>

          <!-- Loading State -->
          <div *ngIf="isPowerTrain && powertrainImageLoader" class="images-grid">
            <div class="skeleton-card" *ngFor="let i of [1,2,3,4]"></div>
          </div>

          <!-- Powertrain Images -->
          <div *ngIf="isPowerTrain && !powertrainImageLoader" class="images-grid">
            <div class="image-card" *ngFor="let image of powerTrainImages" (click)="updatePowertrainImage(image)">
              <img [src]="image.image_path" [alt]="image.image_alt" />
              <div class="image-overlay">
                <i class="fas fa-plus"></i>
              </div>
            </div>
          </div>
        </div>

        <!-- Asset Details Panel -->
        <div class="sidebar-section" *ngIf="powertrainSelectedSensor.assetType">
          <h3 class="sidebar-title">
            <i class="fas fa-info-circle"></i>
            Sensor Details
          </h3>
          <div class="details-card">
            <div class="detail-item">
              <span class="detail-label">Asset Type</span>
              <span class="detail-value">{{ powertrainSelectedSensor.assetType || '-' }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">Sub Type</span>
              <span class="detail-value">{{ powertrainSelectedSensor.subType || '-' }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">Marker</span>
              <span class="detail-value badge">{{ powertrainSelectedSensor.assetMarker || '-' }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">Master Type</span>
              <span class="detail-value badge">{{ powertrainSelectedSensor.master_type==4?'Piezo':
                                                  powertrainSelectedSensor.master_type==3?"Em-Std+RTDs":  
                                                  powertrainSelectedSensor.master_type==2?"Em-Standard":'Em-Mini'
                                               }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Main Canvas Area -->
    <div class="canvas-area example-boundary" id="canvas-container" #canvasContainer>
      <div class="canvas-content" *ngIf="isPowerTrain">
        <div class="powertrain-item" *ngFor="let item of powertrainCanvasItems"
          [ngClass]="{ 'selected': selectedAsset.id == item.id }" id="asset-{{ item.id }}"
          (click)="onCanvasItemClick(item)">
          <img [src]="item.image_path" class="item-image" />

          <!-- Sensors -->
          <div *ngFor="let sensor of item.sensors; let i = index" (click)="onPowertrainSensorClick(item, i)" cdkDrag
            cdkDragBoundary="#asset-{{ item.id }}" (cdkDragEnded)="onPowertrainSensorDragEnd($event, sensor)"
            class="sensor-marker powertrain-sensor" [ngStyle]="{
            top: sensor.yPercentages?sensor.yPercentages + '%':'0px',
            left: sensor.xPercentages?sensor.xPercentages + '%':'0px',
          }" [class.selected]="powertrainSelectedSensor.sensor_number === sensor.sensor_number">
            {{ sensor.sensorMarker }}
          </div>
        </div>

        <div class="empty-canvas" *ngIf="!powertrainCanvasItems.length">
          <i class="fas fa-image"></i>
          <p>Select a piezeo image to begin</p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modals -->
<app-powertrain-modal [type]="'piezo_asset_selection'" [data]="{ isMaster: powerTrainSensorsNumber }"
  *ngIf="openPowertrainSensorModal" (closeBox)="closePowerTrainSensorBox($event)"></app-powertrain-modal>

<app-powertrain-modal [type]="'powertrain_name'" [data]="{name:powertrainName}" *ngIf="openPowertrainNameModal" (closeBox)="inputpowertrainForm($event)"></app-powertrain-modal>

<app-file-upload-modal *ngIf="isUploadModalOpen" [type]="'piezeo'" [isOpen]="isUploadModalOpen"
  (closeModal)="closeUploadModal()" (uploadSuccess)="onUploadSuccess($event)" />